export default "__VITE_ASSET__DjAjR7CS__"